import { render, staticRenderFns } from "./OptionsTab.vue?vue&type=template&id=260a36b2&scoped=true&"
import script from "./OptionsTab.vue?vue&type=script&lang=js&"
export * from "./OptionsTab.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTab.vue?vue&type=style&index=0&id=260a36b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a36b2",
  null
  
)

export default component.exports